var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FormInput(_a) {
    var label = _a.label, error = _a.error, registration = _a.registration, className = _a.className, props = __rest(_a, ["label", "error", "registration", "className"]);
    return (_jsxs("div", __assign({ className: "space-y-1" }, { children: [_jsx("label", __assign({ className: "text-sm font-semibold text-gray-700 block" }, { children: label })), _jsx("input", __assign({}, registration, { className: "w-full p-3 border rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#0f4098] focus:border-transparent ".concat(error ? "border-red-500" : "border-gray-300", " ").concat(className || "") }, props)), error && _jsx("p", __assign({ className: "text-red-500 text-sm mt-1" }, { children: error }))] })));
}
